
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PromotionMasterDialog extends Serenity.EntityDialog<PromotionMasterRow, any> {
        protected getFormKey() { return PromotionMasterForm.formKey; }
        protected getIdProperty() { return PromotionMasterRow.idProperty; }
        protected getLocalTextPrefix() { return PromotionMasterRow.localTextPrefix; }
        protected getNameProperty() { return PromotionMasterRow.nameProperty; }
        protected getService() { return PromotionMasterService.baseUrl; }
        protected getDeletePermission() { return PromotionMasterRow.deletePermission; }
        protected getInsertPermission() { return PromotionMasterRow.insertPermission; }
        protected getUpdatePermission() { return PromotionMasterRow.updatePermission; }

        protected form = new PromotionMasterForm(this.idPrefix);

        constructor() {
            super();

            this.form.DiscountOn.changeSelect2(e => {
                if (this.form.DiscountOn.value == "1") {
                    Serenity.EditorUtils.setReadOnly(this.form.DiscountPercentage, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscountAmount, false);
                }


                if (this.form.DiscountOn.value == "2") {
                    Serenity.EditorUtils.setReadOnly(this.form.DiscountAmount, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscountPercentage, false);
                }
            });
        }

        onDialogOpen() {
            super.onDialogOpen();
            if (this.form.PromoCode.value == "") {
                const code = Math.random().toString(20).substr(2, 6);
                //   Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);  // Math.random().toString(36).substr(2, 5);
                this.form.PromoCode.value = code.toString().toUpperCase();
            }
            Serenity.EditorUtils.setReadOnly(this.form.PromoCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscountAmount, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscountPercentage, true);

        }
    }
}